export default "__VITE_ASSET__ZSXtGphu__"